import { render, staticRenderFns } from "./box-radio.vue?vue&type=template&id=d92614b6&scoped=true"
import script from "./box-radio.vue?vue&type=script&lang=js"
export * from "./box-radio.vue?vue&type=script&lang=js"
import style0 from "./box-radio.vue?vue&type=style&index=0&id=d92614b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92614b6",
  null
  
)

export default component.exports